<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="m-portlet m-portlet--tab">
          <div class="m-portlet__body">
            <div>
              <span class="loading-request" v-show="loading"></span>
              <div
                class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pb-2 mb-4 border-bottom"
              >
                <h1 class="h2">Descontos Aplicados</h1>
              </div>
              <div
                id="alert"
                class="alert alert-dismissible fade show  m-alert m-alert--outline mb-4 mt-4"
                :class="alert.color"
                role="alert"
                v-if="alert.message"
              >
                <button
                  type="button"
                  class="close"
                  aria-label="Close"
                  @click="alert.message = ''"
                ></button>
                <i :class="alert.icon"></i> &nbsp;<strong>{{ alert.message }}</strong
                ><br />
                {{ alert.reason }}
              </div>
              <div class="col-md-5">
                <select-customers
                  :first="'Selecione um cliente'"
                  @change="getDatas($event)"
                ></select-customers>
              </div>
              <div class="page-amounts">
                <nav aria-label="...">
                  <ul class="pagination pagination-md">
                    <li class="page-item" :class="{ selected: amount === 3 }">
                      <a @click="amount = 3" class="page-link paginate">3</a>
                    </li>
                    <li class="page-item" :class="{ selected: amount === 10 }">
                      <a @click="amount = 10" class="page-link paginate">10</a>
                    </li>
                    <li class="page-item" :class="{ selected: amount === 50 }">
                      <a @click="amount = 50" class="page-link paginate">50</a>
                    </li>
                    <li class="page-item" :class="{ selected: amount === 100 }">
                      <a @click="amount = 100" class="page-link paginate">100</a>
                    </li>
                    <li class="page-item" :class="{ selected: amount === 150 }">
                      <a @click="amount = 150" class="page-link paginate">150</a>
                    </li>
                  </ul>
                </nav>
              </div>
              <div class="paginator-info-top m-2">
                <span class="m--font-gray" v-if="data.from"
                  >Exibindo itens de {{ data.from }} a {{ data.to }}, de um total de
                  {{ data.total }}.</span
                >
                <span class="m--font-gray" v-else>Nenhum item a ser exibido.</span>
              </div>
            </div>
            <div class="table-responsive">
              <div class="container-table">
                <table class="table table-striped- table-bordered table-hover table-checkable">
                  <thead>
                    <tr>
                      <td nowrap class="text-center align-middle pointer" width="60">Data</td>
                      <td nowrap class="text-center align-middle" width="150">Desconto aplicado</td>
                      <td nowrap class="text-center align-middle" width="150">
                        Responsável pelo desconto
                      </td>
                      <td nowrap class="text-center align-middle" width="30">Produto</td>
                      <td nowrap class="text-center align-middle" width="50">Fatura</td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(extract, id) in data.data" :key="id">
                      <td class="text-center align-middle">{{ extract.date | month }}</td>
                      <td class="text-center align-middle">{{ extract.amount | money }}</td>
                      <td class="text-center align-middle">{{ extract.discount.user.name }}</td>
                      <td class="text-center align-middle">
                        {{ extract.discount.product.name }}
                      </td>
                      <td class="text-center align-middle">
                        <router-link
                          :to="{
                            name: 'customer-invoice',
                            params: {
                              customerId: extract.discount.customer_id,
                              invoiceId: extract.invoice_id,
                            },
                          }"
                        >
                          {{ extract.invoice_id }}
                        </router-link>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div>
              <div class="paginator-info-bottom mt-2">
                <span class="m--font-gray" v-if="data.from"
                  >Exibindo itens de {{ data.from }} a {{ data.to }}, de um total de
                  {{ data.total }}.</span
                >
                <span class="m--font-gray" v-else>Nenhum item a ser exibido.</span>
              </div>
              <div class="paginator-list">
                <nav aria-label="...">
                  <ul class="pagination pagination-md">
                    <li class="page-item" :class="{ disabled: data.current_page === 1 }">
                      <a class="page-link paginate" @click="page = 1"
                        ><i class="fal fa-angle-double-left"></i
                      ></a>
                    </li>
                    <li class="page-item" :class="{ disabled: data.current_page === 1 }">
                      <a class="page-link paginate" @click="page = data.current_page - 1"
                        ><i class="fal fa-angle-left"></i
                      ></a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page === 1 }"
                      v-if="data.current_page > 2"
                    >
                      <a class="page-link paginate" @click="page = data.current_page - 2">
                        {{ data.current_page - 2 }}</a
                      >
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page === 1 }"
                      v-if="data.current_page > 1"
                    >
                      <a class="page-link paginate" @click="page = data.current_page - 1">
                        {{ data.current_page - 1 }}</a
                      >
                    </li>
                    <li class="page-item selected">
                      <a class="page-link paginate"> {{ data.current_page }} </a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page === data.last_page }"
                      v-if="data.current_page < data.last_page"
                    >
                      <a class="page-link paginate" @click="page = data.current_page + 1">
                        {{ data.current_page + 1 }}
                      </a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page + 1 === data.last_page }"
                      v-if="data.current_page + 1 < data.last_page"
                    >
                      <a class="page-link paginate" @click="page = data.current_page + 2">
                        {{ data.current_page + 2 }}
                      </a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page === data.last_page }"
                    >
                      <a class="page-link paginate" @click="page = data.current_page + 1"
                        ><i class="fal fa-angle-right"></i
                      ></a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page === data.last_page }"
                    >
                      <a class="page-link paginate" @click="page = data.last_page"
                        ><i class="fal fa-angle-double-right"></i
                      ></a>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
            <div class="pt-4"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { returnMessageMixin } from '@/mixins/returnMessageMixin.js';
import { baseApiUrl } from '@/global';
import axios from 'axios';
import SelectCustomers from '../forms/SelectCustomers';

export default {
  mixins: [returnMessageMixin],
  name: 'Discount',
  components: { SelectCustomers },
  data() {
    return {
      data: {},
      amount: localStorage.customerDiscountExtractDataAmount
        ? localStorage.customerDiscountExtractDataAmount
        : 100,
      page: localStorage.customerDiscountExtractDataPage
        ? localStorage.customerDiscountExtractDataPage
        : 1,
      alert: {},
    };
  },
  computed: {
    loading() {
      return false;
    },
  },
  methods: {
    callData() {
      this.data.current_page = null;
      this.setStorageFilters();
      this.getDatas();
    },
    getDatas(id) {
      this.messageWaitingSave();
      const url = `${baseApiUrl}/v1/customer/${id}/discounts/applied`;
      axios(url)
        .then((res) => {
          this.data = res.data;
          if (res.data.current_page > res.data.last_page) {
            this.page = 1;
          }
          this.alert = {};
        })
        .catch((error) => {
          this.logMessageFormFailed(error.response);
        });
    },
    messageWaitingSave() {
      this.alert = {
        color: 'alert-primary',
        icon: 'fas fa-spinner fa-spin fa-lg',
        message: 'Aguarde, buscando dados!',
        reason: '',
      };
    },
    getIconProducts({ icon }) {
      if (icon) {
        return require(`@/assets/media/img/icons/${icon}.svg`);
      }
    },
  },
  watch: {
    page() {
      this.callData();
    },
  },
  mounted() {
    window.scroll(0, 0);
  },
};
</script>
